module.exports = __webpack_public_path__ + "static/media/FijiTv_Fiji.35cf67ee.png";